import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const NeobuxSection = () => {
  return (
    <section className="py-16 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold mb-4">Estratégias para Neobux</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Descubra como maximizar seus ganhos no Neobux com nossas estratégias exclusivas
            para acertar pesquisas e aumentar sua renda online.
          </p>
        </div>

        <Card className="overflow-hidden shadow-xl">
          <div className="grid md:grid-cols-2">
            <div className="bg-gradient-to-r from-blue-600 to-indigo-700 p-8 text-white flex flex-col justify-center">
              <h3 className="text-2xl font-bold mb-4">Aumente seus ganhos no Neobux</h3>
              <ul className="space-y-2 mb-6">
                <li className="flex items-start">
                  <span className="mr-2">✓</span>
                  <span>Estratégias para acertar pesquisas de $0,21 e $0,01</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">✓</span>
                  <span>Coleção de dicas no Pinterest</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">✓</span>
                  <span>Guias detalhados para iniciantes e avançados</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">✓</span>
                  <span>Técnicas para maximizar seus referidos</span>
                </li>
              </ul>
              <Link to="/neobux-estrategia">
                <Button variant="secondary" className="mt-2">
                  Ver Estratégias <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
            </div>
            <CardContent className="p-8 flex items-center">
              <div>
                <h3 className="text-2xl font-bold mb-4">Recursos Exclusivos</h3>
                <p className="mb-6">
                  Acesse nossa playlist completa no Pinterest com estratégias testadas e aprovadas
                  para maximizar seus ganhos no Neobux. Aprenda como acertar pesquisas valiosas
                  e desenvolva um sistema consistente de renda online.
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <Button 
                    onClick={() => window.open("https://br.pinterest.com/crisgride/eatrategia-neobux/", "_blank")}
                    variant="outline"
                  >
                    Pinterest
                  </Button>
                  <Button 
                    onClick={() => window.open("https://lucropagina.blogspot.com/2025/04/acertando-pesquisa-no-neobux.html", "_blank")}
                    variant="outline"
                  >
                    Guia de Pesquisas
                  </Button>
                  <Link to="/neobux-cadastro">
                    <Button className="w-full">
                      Criar Conta Neobux
                    </Button>
                  </Link>
                </div>
              </div>
            </CardContent>
          </div>
        </Card>
      </div>
    </section>
  );
};

export default NeobuxSection;